// WeDev Start - Back in stock waitlist helpers (shared by variant-options + mix-match picker)
window.getWaitlistRoot = function () {
  const swWidget = document.querySelector("#sealapps-bis-widget");
  if (swWidget) {
    return swWidget.closest(".shopify-app-block") || swWidget;
  }

  const esWidget = document.querySelector(".product-restore-email");
  if (esWidget) {
    return esWidget.closest(".shopify-app-block") || esWidget;
  }

  const emailButton = document.querySelector(".email-me-button");
  if (emailButton) {
    return emailButton.closest(".shopify-app-block") || emailButton.parentElement;
  }

  return null;
};

window.applyWaitlistVisibility = function (show) {
  const waitlistRoot = window.getWaitlistRoot();
  if (!waitlistRoot) return false;

  waitlistRoot.classList.toggle("wd-waitlist-root--visible", show);
  waitlistRoot.classList.toggle("wd-waitlist-root--hidden", !show);
  waitlistRoot.style.removeProperty("display");

  if (show) {
    window.ensureWaitlistButton?.(true);
  } else {
    window.ensureWaitlistButton?.(false);
  }

  return true;
};

window.ensureWaitlistButton = function (show) {
  const widget =
    document.querySelector("#sealapps-bis-widget") ||
    document.querySelector(".product-restore-email");
  if (!widget) return;

  const appButton = widget.querySelector(
    ".email-me-button:not(.wd-fallback-notify-btn), button:not(.wd-fallback-notify-btn)",
  );

  if (!show) {
    widget.querySelector(".wd-fallback-notify-btn")?.remove();
    return;
  }

  if (appButton && appButton.textContent.trim()) {
    widget.querySelector(".wd-fallback-notify-btn")?.remove();
    return;
  }

  if (widget.querySelector(".wd-fallback-notify-btn")) return;

  const fallback = document.createElement("button");
  fallback.type = "button";
  fallback.className =
    "wd-fallback-notify-btn email-me-button button button--full-width";
  fallback.textContent = "EMAIL ME WHEN AVAILABLE";
  fallback.addEventListener("click", () => {
    const target = document.querySelector(
      ".email-me-button:not(.wd-fallback-notify-btn), .product-restore-email button:not(.wd-fallback-notify-btn)",
    );
    if (target) {
      target.click();
      return;
    }

    document
      .querySelectorAll('form[data-type="add-to-cart-form"] input[name="id"]')
      .forEach((input) => {
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
    window.dispatchEvent(new Event("locationchange"));
  });
  widget.appendChild(fallback);
};

window.setWaitlistVisible = function (show) {
  if (window.applyWaitlistVisibility(show)) return;

  if (!show) return;

  let attempts = 0;
  const interval = setInterval(() => {
    attempts += 1;
    if (window.applyWaitlistVisibility(true) || attempts >= 80) {
      clearInterval(interval);
      if (attempts < 80) {
        setTimeout(() => window.ensureWaitlistButton?.(true), 300);
        setTimeout(() => window.ensureWaitlistButton?.(true), 1500);
      }
    }
  }, 100);
};

window.unlockVariantSizeInput = function (input, label) {
  if (!input) return;
  input.disabled = false;
  input.removeAttribute("disabled");
  input.classList.remove("disabled");
  if (!label) return;
  label.classList.remove("disabled");
  label.removeAttribute("aria-disabled");
};

window.markVariantSizeSoldOut = function (input, label, soldOut) {
  window.unlockVariantSizeInput(input, label);
  input?.classList.toggle("wd-variant-size--sold-out", soldOut);
  label?.classList.toggle("wd-variant-size--sold-out", soldOut);
};

window.getBuyButtonContainer = function (sectionId) {
  return (
    document.querySelector(
      `.main-product__buy-buttons--container[data-section-id="${sectionId}"]`,
    ) ||
    document
      .getElementById(`ProductForm-${sectionId}`)
      ?.closest(".main-product__buy-buttons--container") ||
    document.querySelector(".main-product__buy-buttons--container")
  );
};
// WeDev End

if (!customElements.get("variant-options")) {
  
  // WeDev Start 
  // --- Global accessor for current variant ---
  window.getCurrentSelectedVariant = function() {
    const el = document.querySelector('variant-options');
    return el?.currentVariant || null;
  };

  window.getCurrentVariants = function() {
    return document.querySelector('variant-options').variantData || [];

  };
  // WeDev End 


  customElements.define(
    "variant-options",
    class VariantOptions extends HTMLElement {
      whenLoaded = Promise.all([customElements.whenDefined("gallery-section")]);
      constructor() {
        super();
        this.addEventListener("change", this.onVariantChange);
        this.addEventListener("keydown", this.onKeyDown);

        this.container = document.querySelector(
          `section[data-product-handle="${this.getAttribute("data-product-handle")}"]`,
        );
      }

      connectedCallback() {
        this.whenLoaded.then(() => {
          this.initialize();
        });
      }

      disconnectedCallback() {}

      initialize() {
        this.updateOptions();
        this.updateMasterId();
        this.updateGallery();
        this.updateVariantStatuses();
        this.updateDropdownButtons();
        
        // WeDev Start - Filter sizes based on selected color on initial load
        this.filterSizesBySelectedColor();
        this.markSoldOutSizes();
        this.syncSelectedOptionLabels();
        this.ensureInitialVariant();
        this.updateVariantInput();
        this.syncAddButtonVisibility();
        // WeDev End
      }

      // WeDev Start - Sold-out / waitlist buy button visibility
      ensureInitialVariant() {
        if (this.currentVariant) return;

        const hasChecked = this.querySelector(
          '.wt-product__option input[type="radio"]:checked',
        );
        // WeDev Start - Retry match when size is pre-checked but Color is hidden via product siblings
        // Original:
        // if (hasChecked) return;
        if (hasChecked) {
          this.updateOptions();
          this.updateMasterId();
          if (this.currentVariant) return;
        }
        // WeDev End

        if (!this.variantData) {
          this.variantData = this.getVariantData();
        }

        const fallbackVariant =
          this.variantData?.find((variant) => variant.available) ||
          this.variantData?.[0];
        if (!fallbackVariant) return;

        this.selectVariantOptions(fallbackVariant);
        this.updateOptions();
        this.updateMasterId();
      }

      selectVariantOptions(variant) {
        this.querySelectorAll(".wt-product__option").forEach((container) => {
          const position = this.getOptionPosition(container);
          if (!position) return;

          const value = variant[`option${position}`];
          if (!value) return;

          const input = [
            ...container.querySelectorAll('input[type="radio"]'),
          ].find((radio) => radio.value === value);
          if (input) input.checked = true;
        });
      }

      syncAddButtonVisibility() {
        const sectionId = this.dataset.section;
        const addButton = document.getElementById(
          `ProductSubmitButton-${sectionId}`,
        );
        const addButtonContainer = window.getBuyButtonContainer(sectionId);
        if (!addButton || !addButtonContainer) return;

        const addButtonText = addButton.querySelector("span");
        const formWrap = document.getElementById(`ProductForm-${sectionId}`);
        const preOrder = formWrap?.getAttribute("data-pre");

        if (!this.currentVariant) {
          addButtonContainer.classList.remove("wd-buy-buttons--hidden");
          addButtonContainer.classList.remove("scroll-trigger--offscreen");
          addButtonContainer.classList.add("scroll-trigger--cancel");
          addButtonContainer.style.display = "flex";
          addButtonContainer.style.opacity = "1";
          addButtonContainer.style.transform = "none";
          addButton.style.display = "";
          addButton.setAttribute("disabled", "disabled");
          if (addButtonText) {
            addButtonText.textContent =
              window.variantStrings?.selectSize || "Select a size";
          }
          window.setWaitlistVisible(false);
          this.updateInventoryStatus();
          return;
        }

        if (this.currentVariant.available) {
          addButtonContainer.classList.remove("wd-buy-buttons--hidden");
          addButtonContainer.classList.remove("scroll-trigger--offscreen");
          addButtonContainer.classList.add("scroll-trigger--cancel");
          addButtonContainer.style.display = "flex";
          addButtonContainer.style.opacity = "1";
          addButtonContainer.style.transform = "none";
          addButton.style.display = "";
          addButton.removeAttribute("disabled");

          if (addButtonText) {
            addButtonText.textContent = preOrder
              ? "Pre order"
              : window.variantStrings.addToCart;
          }

          window.setWaitlistVisible(false);
          this.updateInventoryStatus();
          return;
        }

        addButton.setAttribute("disabled", "disabled");
        if (addButtonText && window.variantStrings?.soldOut) {
          addButtonText.textContent = window.variantStrings.soldOut;
        }
        addButton.style.display = "none";
        addButtonContainer.style.display = "none";
        addButtonContainer.classList.add("wd-buy-buttons--hidden");

        this.updateVariantInput();
        window.setWaitlistVisible(true);

        this.updateInventoryStatus();
      }

      updateInventoryStatus() {
        const inventory = document.getElementById(
          `Inventory-${this.dataset.section}`,
        );
        const statusText = inventory?.querySelector("span");
        if (!statusText) return;

        if (!statusText.dataset.wdInStockText) {
          statusText.dataset.wdInStockText =
            window.variantStrings?.inStock || statusText.textContent;
        }

        if (this.currentVariant && !this.currentVariant.available) {
          statusText.textContent =
            window.variantStrings?.soldOut || "Sold out";
        } else if (this.currentVariant?.available) {
          statusText.textContent = statusText.dataset.wdInStockText;
        }
      }
      // WeDev End

      onKeyDown(event) {
        if (event.key === "Enter" || event.keyCode === 13) {
          const input = event.target.querySelector("input");
          input?.click();
          // this.onVariantChange();
        }
      }

      onVariantChange() {
        const variantChangeStartEvent = new CustomEvent("variantChangeStart", {
          bubbles: true,
          composed: true,
        });
        this.dispatchEvent(variantChangeStartEvent);
        this.updateOptions();
        this.updateMasterId();
        this.updateGallery();
        this.toggleAddButton(true, "", false);
        this.updatePickupAvailability();
        this.removeErrorMessage();
        this.updateVariantStatuses();
        this.updateDropdownButtons();
        
        // WeDev Start - Filter sizes based on selected color
        this.filterSizesBySelectedColor();
        this.markSoldOutSizes();
        this.syncSelectedOptionLabels();
        // WeDev End
        
        if (!this.currentVariant) {
          this.toggleAddButton(true, window.variantStrings?.selectSize || "Select a size", false);
          return;
        } else {
          this.updateMedia();
          this.lenOfVariantOptions =
            document.querySelectorAll("variant-options").length;
          if (this.lenOfVariantOptions === 1) {
            this.updateURL();
          }
          this.updateVariantInput();
          this.renderProductInfo();
          this.updateShareUrl();
          // WeDev Start
          this.syncAddButtonVisibility();
          // WeDev End
        }
        const variantChangeEndEvent = new CustomEvent("variantChangeEnd", {
          bubbles: true,
          composed: true,
        });
        this.dispatchEvent(variantChangeEndEvent);
      }

      updateGallery() {
        const mediaGallery = document.getElementById(
          `MediaGallery-${this.dataset.section}`,
        );

        let media_id = false;
        if (this.currentVariant && this.currentVariant.featured_media) {
          media_id = this.currentVariant.featured_media.id;
        }

        mediaGallery?.filterSlides(this.options, media_id, true);
      }

      updateDropdownButtons(){
        const fieldsets = Array.from(
          this.querySelectorAll(".wt-product__option"),
        );
        // WeDev Start - Keep option positions aligned with data-option-position (Size at index 1, not 0)
        // Original:
        // this.options = fieldsets.map((fieldset) => {
        //   return Array.from(fieldset.querySelectorAll("input")).find(
        //     (radio) => radio.checked,
        //   )?.value || '';
        // });
        this.options = this.getOrderedSelectedOptions(fieldsets);
        // WeDev End

        fieldsets.forEach((fieldset) => {
          const dropdown = fieldset.querySelector(
            ".wt-product__option__dropdown",
          );
          if (dropdown) {
            const checkedInput = fieldset.querySelector('fieldset input:checked')
            if(!checkedInput) return
            const isInputDisabled = checkedInput?.classList.contains('disabled')
            dropdown.classList.toggle('wt-product__option__dropdown--unavailable', isInputDisabled)
          }
        });
      }

      updateOptions() {
        const fieldsets = Array.from(
          this.querySelectorAll(".wt-product__option"),
        );
        this.displayOptions = [];
        fieldsets.forEach((fieldset, index) => {
          this.displayOptions[index] =
            Array.from(fieldset.querySelectorAll("input")).find(
              (radio) => radio.checked,
            )?.value || "";
        });
        this.options = this.getOrderedSelectedOptions(fieldsets);

        this.checkedOptions = [];
        fieldsets.forEach((fieldset, index) => {
          this.checkedOptions[index] =
            Array.from(fieldset.querySelectorAll("input")).find(
              (radio) => radio.checked,
            ) || '';
        });

        fieldsets.forEach((fieldset, index) => {
          const selectedOption = this.displayOptions[index];

          if (!selectedOption) return;

          fieldset.querySelector(
            ".wt-product__option__title .value",
          ).innerHTML = selectedOption;
          const dropdownSpan = fieldset.querySelector(
            ".wt-product__option__dropdown span",
          );
          if (dropdownSpan) dropdownSpan.innerHTML = selectedOption;
        });
      }

      // WeDev Start - Match variants by rendered options only; sibling products hide Color in variant-options
      // Original updateMasterId:
      // updateMasterId() {
      //   this.currentVariant = this.getVariantData()?.find((variant) => {
      //     return !variant.options
      //       .map((option, index) => {
      //         return this.options[index] === option;
      //       })
      //       .includes(false);
      //   });
      // }
      getRenderedOptionPositions() {
        return [...this.querySelectorAll(".wt-product__option")]
          .map((container) => this.getOptionPosition(container))
          .filter(Boolean);
      }

      findVariantForOptions(testOptions) {
        const renderedPositions = this.getRenderedOptionPositions();
        return this.getVariantData()?.find((variant) => {
          if (!renderedPositions.length) {
            // Fallback: no position metadata — all options must be rendered and testOptions fully populated by index
            return !variant.options
              .map((option, index) => testOptions[index] === option)
              .includes(false);
          }

          return renderedPositions.every((position) => {
            return testOptions[position - 1] === variant.options[position - 1];
          });
        });
      }

      updateMasterId() {
        this.currentVariant = this.findVariantForOptions(this.options);
      }
      // WeDev End

      updateMedia() {
        if (!this.currentVariant) return;
        this.setAttribute("data-variant-id", this.currentVariant?.id);
        if (!this.currentVariant.featured_media) return;
        this.setAttribute(
          "data-featured-image",
          this.currentVariant?.featured_media?.preview_image?.src,
        );
        this.setAttribute(
          "data-featured-image-id",
          this.currentVariant?.featured_media?.id,
        );

        const modalContent = document.querySelector(
          `#ProductModal-${this.dataset.section} .product-media-modal__content`,
        );
        if (!modalContent) return;
        const newMediaModal = modalContent.querySelector(
          `[data-media-id="${this.currentVariant.featured_media.id}"]`,
        );
        modalContent.prepend(newMediaModal);
      }

      updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === "false") return;
        window.history.replaceState(
          {},
          "",
          `${this.dataset.url}?variant=${this.currentVariant.id}`,
        );
      }

      updateShareUrl() {
        const shareButton = document.getElementById(
          `Share-${this.dataset.section}`,
        );
        if (!shareButton || !shareButton.updateUrl) return;
        shareButton.updateUrl(
          `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`,
        );
      }

      // WeDev Start - Keep variant id in sync for Back In Stock app
      updateVariantInput() {
        if (!this.currentVariant) return;

        const productForms = document.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
        );
        productForms.forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          if (!input) return;
          input.value = this.currentVariant.id;
          input.setAttribute("value", String(this.currentVariant.id));
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });

        window.dispatchEvent(new Event("locationchange"));
      }
      // WeDev End

      updateVariantStatuses() {
        // const selectedOptionOneVariants = this.variantData.filter(
        //   (variant) => this.querySelector(':checked').value === variant.option1
        //   );
        const selectedOptionOneVariants = this.variantData?.filter(
          (variant) => variant.available === true,
        );
        const inputWrappers = [
          ...this.querySelectorAll(".product-form__input"),
        ];
        inputWrappers.forEach((option, index) => {
          if (index === 0 && this.currentVariant?.options.length > 1) return;
          const optionInputs = [
            ...option.querySelectorAll('input[type="radio"], option'),
          ];
          const previousOptionSelected =
            inputWrappers[index - 1]?.querySelector(":checked")?.value;
          const availableOptionInputsValue = selectedOptionOneVariants
            .filter(
              (variant) =>
                variant.available &&
                variant[`option${index}`] === previousOptionSelected,
            )
            .map((variantOption) => variantOption[`option${index + 1}`]);
          this.setInputAvailability(optionInputs, availableOptionInputsValue);
        });
      }

      setInputAvailability(listOfOptions, listOfAvailableOptions) {
      // WeDev Start
      // Disable unavailable options instead of hiding them
      //        listOfOptions.forEach((input) => {
      //          if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
      //           input.classList.remove("disabled");
      //         } else {
      //           input.classList.add("disabled");
      //         }
      //        });
      }

      syncSelectedOptionLabels() {
        this.querySelectorAll('.wt-product__option').forEach((container) => {
          container.querySelectorAll('input[type="radio"]').forEach((input) => {
            const label = container.querySelector(`label[for="${input.id}"]`);
            if (!label) return;
            label.classList.toggle('wd-variant-selected', input.checked);
          });
        });
      }

      getOptionPosition(container) {
        const dataPosition = Number(container?.dataset?.optionPosition);
        if (Number.isFinite(dataPosition) && dataPosition > 0) return dataPosition;

        const input = container.querySelector('input[type="radio"]');
        const idParts = input?.id?.split('-') || [];
        const position = Number(idParts[idParts.length - 2]);
        return Number.isFinite(position) ? position : null;
      }

      getOrderedSelectedOptions(fieldsets) {
        const orderedValues = [];

        fieldsets.forEach((fieldset, index) => {
          const value = Array.from(fieldset.querySelectorAll("input")).find(
            (radio) => radio.checked,
          )?.value || "";
          const optionPosition = this.getOptionPosition(fieldset) || index + 1;
          orderedValues[optionPosition - 1] = value;
        });

        return orderedValues;
      }

      // WeDev Start - Helper function to filter sizes based on selected color
      markSoldOutSizes() {
        if (!this.variantData) {
          this.variantData = this.getVariantData();
        }

        const fieldsets = [...this.querySelectorAll(".wt-product__option")];

        fieldsets.forEach((container) => {
          container
            .querySelectorAll(
              '.f-button__list__item input[type="radio"], .drawer__list__item input[type="radio"]',
            )
            .forEach((input) => {
              const label = container.querySelector(
                `label[for="${CSS.escape(input.id)}"]`,
              );
              const optionItem = input.closest(
                ".f-button__list__item, .drawer__list__item",
              );
              if (optionItem?.style.display === "none") return;

              const testOptions = this.getOrderedSelectedOptions(fieldsets);
              const position = this.getOptionPosition(container);
              if (position) testOptions[position - 1] = input.value;

              // WeDev Start - Use rendered-option matching (same as updateMasterId)
              // Original:
              // const variant = this.variantData?.find((item) =>
              //   !item.options
              //     .map((option, index) => testOptions[index] === option)
              //     .includes(false),
              // );
              const variant = this.findVariantForOptions(testOptions);
              // WeDev End

              window.markVariantSizeSoldOut(
                input,
                label,
                Boolean(variant && !variant.available),
              );
            });
        });
      }

      filterSizesBySelectedColor() {
        if (!this.variantData) {
          this.variantData = this.getVariantData();
        }

        const getOptionPosition = (container) => this.getOptionPosition(container);

        const optionContainers = [...this.querySelectorAll('.wt-product__option')];
        if (optionContainers.length < 2) return;

        let colorIndex = -1;
        let colorContainer = null;

        optionContainers.forEach((container, index) => {
          const firstInput = container.querySelector('input[type="radio"]');
          const inputName = firstInput?.name?.toLowerCase() || '';
          if (inputName.includes('color') || inputName.includes('צבע')) {
            colorIndex = index;
            colorContainer = container;
          }
        });

        const selectedColorInput = colorContainer?.querySelector('input[type="radio"]:checked');
        if (colorIndex < 0 || !selectedColorInput) return;

        const selectedColor = selectedColorInput.value;
        const colorPosition = getOptionPosition(colorContainer);
        if (!colorPosition) return;

        const colorOptionKey = `option${colorPosition}`;
        const variantsForColor = this.variantData.filter((variant) => variant[colorOptionKey] === selectedColor);

        optionContainers.forEach((container, index) => {
          if (index === colorIndex) return;

          const optionPosition = getOptionPosition(container);
          if (!optionPosition) return;

          const optionKey = `option${optionPosition}`;
          const valuesForColor = variantsForColor.map((variant) => variant[optionKey]).filter(Boolean);
          const availableValuesForColor = variantsForColor
            .filter((variant) => variant.available)
            .map((variant) => variant[optionKey])
            .filter(Boolean);

          container.querySelectorAll('.f-button__list__item, .f-swatch__list__item, .drawer__list__item').forEach((optionItem) => {
            const input = optionItem.querySelector('input[type="radio"]');
            const label = optionItem.querySelector('label');
            if (!input || !label) return;

            const existsForColor = valuesForColor.includes(input.value);
            const isAvailable = availableValuesForColor.includes(input.value);

            optionItem.style.display = existsForColor ? '' : 'none';
            window.markVariantSizeSoldOut(
              input,
              label,
              existsForColor && !isAvailable,
            );
          });
        });
        this.syncSelectedOptionLabels();
      }
      // WeDev End

      updatePickupAvailability() {
        const pickUpAvailability = document.querySelector(
          "pickup-availability",
        );
        if (!pickUpAvailability) return;

        pickUpAvailability.dataset.variantId = this.currentVariant?.id;
        if (this.currentVariant && this.currentVariant.available) {
          pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
          pickUpAvailability.removeAttribute("available");
          pickUpAvailability.innerHTML = "";
        }
      }

      removeErrorMessage() {
        const section = this.closest("section");
        if (!section) return;

        const productForm = section.querySelector("product-form");
        try {
          productForm?.handleErrorMessage();
        } catch (err) {
          console.log(err);
        }
      }

      renderProductInfo() {
        const requestedVariantId = this.currentVariant?.id;
        const sectionId = this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section;

        fetch(
          `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        )
          .then((response) => response.text())
          .then((responseText) => {
            // prevent unnecessary ui changes from abandoned selections
            if (this.currentVariant?.id !== requestedVariantId) return;

            const html = new DOMParser().parseFromString(
              responseText,
              "text/html",
            );
            const destination = document.getElementById(
              `price-${this.dataset.section}`,
            );
            const source = html.getElementById(
              `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
            );
            const skuSource = html.getElementById(
              `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
            );
            const skuDestination = document.getElementById(
              `Sku-${this.dataset.section}`,
            );
            const inventorySource = html.getElementById(
              `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
            );
            const inventoryDestination = document.getElementById(
              `Inventory-${this.dataset.section}`,
            );

            if (source && destination) destination.innerHTML = source.innerHTML;
            if (inventorySource && inventoryDestination)
              inventoryDestination.innerHTML = inventorySource.innerHTML;
            if (skuSource && skuDestination) {
              skuDestination.innerHTML = skuSource.innerHTML;
              skuDestination.classList.toggle(
                "visibility-hidden",
                skuSource.classList.contains("visibility-hidden"),
              );
            }

            const price = document.getElementById(
              `price-${this.dataset.section}`,
            );

            if (price) price.classList.remove("visibility-hidden");

            if (inventoryDestination)
              inventoryDestination.classList.toggle(
                "visibility-hidden",
                inventorySource.innerText === "",
              );

            // WeDev Start
            this.syncAddButtonVisibility();
            // WeDev End

            publish(PUB_SUB_EVENTS.variantChange, {
              data: {
                sectionId: sectionId,
                html,
                variant:this.currentVariant
              },
            });
          });
      }

      // WeDev Start
      toggleAddButton(disable = true, text, modifyClass = true) {
        if (this.currentVariant) {
          this.syncAddButtonVisibility();
          return;
        }

        const addButton = document.getElementById(
          `ProductSubmitButton-${this.dataset.section}`,
        );
        const addButtonContainer = window.getBuyButtonContainer(
          this.dataset.section,
        );
        if (!addButton || !addButtonContainer) return;

        const addButtonText = addButton.querySelector("span");
        addButtonContainer.classList.remove("wd-buy-buttons--hidden");
        addButtonContainer.style.display = "flex";
        addButton.style.display = "";

        if (disable) {
          addButton.setAttribute("disabled", "disabled");
          if (text && addButtonText) addButtonText.textContent = text;
          if (modifyClass !== false) {
            window.setWaitlistVisible(false);
          }
        }
      }

      setUnavailable() {
        const addButton = document.getElementById(
          `ProductSubmitButton-${this.dataset.section}`,
        );
        const addButtonText = addButton?.querySelector("span");
        const price = document.getElementById(`price-${this.dataset.section}`);
        const inventory = document.getElementById(
          `Inventory-${this.dataset.section}`,
        );
        const sku = document.getElementById(`Sku-${this.dataset.section}`);

        if (!addButton) return;

        const addButtonContainer = window.getBuyButtonContainer(
          this.dataset.section,
        );
        if (addButtonContainer) {
          addButtonContainer.style.display = "none";
          addButtonContainer.classList.add("wd-buy-buttons--hidden");
        }
        addButton.style.display = "none";
        if (addButtonText && window.variantStrings?.unavailable) {
          addButtonText.textContent = window.variantStrings.unavailable;
        }
        window.setWaitlistVisible(false);
        if (price) price.classList.add("visibility-hidden");
        if (inventory) inventory.classList.add("visibility-hidden");
        if (sku) sku.classList.add("visibility-hidden");
      }
      // WeDev End

      getVariantData() {
        this.variantData =
          this.variantData ||
          JSON.parse(
            this.querySelector('[type="application/json"]').textContent,
          );
        return this.variantData;
      }
    },
  );
}
// customElements.define('variant-options', VariantOptions);
